export default __webpack_public_path__ + "static/media/54b54a14e138f1c5d0b2aeb0aab553991636460574675.d8779018.webp";